import { useAtomValue } from 'jotai';
import { testModeAtom } from '@/store';

/**
 * Hook to check if test mode is enabled.
 * Test mode shows incomplete/experimental UI features.
 * Controlled via Admin menu toggle, synced with PostHog feature flag.
 */
export function useTestMode(): boolean {
  return useAtomValue(testModeAtom);
}
